<template>
  <box-model :title="totalPart.indexName || '农产品批发价格200指数'">
    <template v-slot:content>
      <div class="con">
        <div v-if="!show" class="no-data-sty no-data">暂无数据</div>
        <div v-else>
          <div class="up-time">更新时间 {{ totalPart.publishDate || '暂无' }}</div>
          <div class="index-part">
            <div class="i-item grey">
              <div class="i-con">
                <div class="count">{{ totalPart.indexValue }}</div>
                <div class="count">总指数</div>
                <div class="total">{{ totalPart.nextRecordValue }}</div>
                <div class="trend" :class="totalPart.weightValue > 0 ? 'trend-1' : ''">
                  <div class="s" :class="totalPart.weightValue > 0 ? 's2-color' : 's1-color'"></div>
                  <span>{{ totalPart.weightValue }}</span>
                </div>
              </div>
            </div>
            <div class="i-item">
              <div class="top-line"></div>
              <div class="bottom-line"></div>
              <div class="i-con">
                <div class="count b-color">菜篮子产品</div>
                <div class="count b-color">价格指数</div>
                <div class="total">{{ vegetable.nextRecordValue  }}</div>
                <div class="trend" :class="vegetable.weightValue > 0 ? 'trend-1' : ''">
                  <div class="s" :class="vegetable.weightValue > 0 ? 's2-color' : 's1-color'"></div>
                  <span>{{ vegetable.weightValue }}</span>
                </div>
              </div>
            </div>
            <div class="i-item">
              <div class="top-line"></div>
              <div class="bottom-line"></div>
              <div class="i-con">
                <div class="count y-color">粮油产品</div>
                <div class="count y-color">价格指数</div>
                <div class="total">{{ grainData.nextRecordValue }}</div>
                <div class="trend" :class="grainData.weightValue > 0 ? 'trend-1' : ''">
                  <div class="s" :class="grainData.weightValue > 0 ? 's2-color' : 's1-color'"></div>
                  <span>{{ grainData.weightValue }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="statistics">
            <div v-for="(item, index) in statistics" :key="index" class="s-item">
              <div class="s-icon flex-center">
                <img v-if="item.indexType ==='AA'" class="s-img" src="../../assets/img/select/product-5.png" />
                <img v-else-if="item.indexType ==='AF'" class="s-img" src="../../assets/img/select/product-4.png" />
                <img v-else-if="item.indexType ==='AE'" class="s-img" src="../../assets/img/select/product-3.png" />
                <img v-else-if="item.indexType ==='AJ01'" class="s-img" src="../../assets/img/select/product-6.png" />
                <img v-else-if="item.indexType ==='B'" class="s-img" src="../../assets/img/select/product-2.png" />
                <img v-else class="s-img" src="../../assets/img/select/product-1.png" />
              </div>
              <div class="s-name">{{ item.indexName }}</div>
              <div class="s-count flex-y-center">
                <div class="s-num">{{ item.nextRecordValue }}</div>
                <div class="sq flex-y-center" :class="item.weightValue > 0 ? 'sp-1' : ''">
                  <div class="p" :class="item.weightValue > 0 ? 'p2-color' : 'p1-color'"></div>
                  <span>{{ item.weightValue }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import { getPriceIndices } from "@/api/index";
  export default {
    data() {
      return {
        show: false,
        totalPart: {},
        vegetable: {},
        grainData: {},
        statistics: [],
        imgPath: {
          AF: ''
        }
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted(){
      this.getPriceIndicesEvent();
    },
    methods: {
      // 获取农产品指数
      getPriceIndicesEvent(){
        getPriceIndices().then(res => {
          if(!res.data){
            return;
          }
          const result = JSON.parse(res.data);
          this.totalPart = result[0] && result[0][0];
          const two = result[1];
          if(two?.length){
            for(let i=0;i<two.length;i++){
              if(two[i].indexType === "AJ"){
                this.grainData = two[i];
              }
              if(two[i].indexType === "AX"){
                this.vegetable = two[i];
              }
            }
          };
          console.log(result[2], 'result[2]');
          const list = result[2];
          this.statistics = list.filter((item) => {
            return !['畜产品', '水产品'].includes(item.indexName);
          });
          this.show = true;
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .no-data {
    height: 300px;
  }
  .con {
    width: 100%;
    height: 300px;
    .up-time {
      font-size: 14px;
      font-weight: 400;
      color: #4ADDFF;
      line-height: 14px;
    }
    .index-part {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 130px;
      margin-top: 20px;
      .grey {
        background: rgba(255,255,255,0.0784);
      }
      .i-item {
        position: relative;
        width: 120px;
        height: 100%;
        padding: 10px 12px 10px 12px;
        .i-con {
          position: relative;
          z-index: 3;
          .count {
            font-size: 16px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 24px;
          }
          .b-color {
            color: #38EAFF;
          }
          .y-color {
            color: #FFCC00;
          }
          .total {
            font-size: 24px;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 18px;
            margin-top: 18px;
          }
          .trend {
            position: relative;
            font-size: 14px;
            font-weight: 700;
            color: #06F7A1;
            line-height: 14px;
            margin-top: 10px;
            padding-left: 10px;
            .s {
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 0;
              height: 0;
              border: 4px solid;
              margin-right: 4px;
            }
            .s1-color {
              border-color: #06F7A1 transparent transparent transparent;
              margin-top: 4px;
            }
            .s2-color {
              border-color: #FF6637 transparent transparent transparent;
              transform: rotate(180deg);
              margin-top: -6px;
            }
          }
          .trend-1 {
            color: #FF6637;
          }
        }
        .top-line {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          width: 100%;
          height: 10px;
          border: 1px solid #2888F1;
          border-bottom: 0;
        }
        .bottom-line {
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 0;
          width: 100%;
          height: 10px;
          border: 1px solid #2888F1;
          border-top: 0;
        }
      }
    }
    .statistics {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      margin-top: 4px;
      .s-item {
        position: relative;
        width: 180px;
        background: rgba(255,255,255,0.0784);
        padding: 8px;
        margin-top: 10px;
        .s-icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 30px;
          height: 30px;
          .s-img {
            width: 32px;
            height: 32px;
          }
        }
        .s-name {
          font-size: 14px;
          font-weight: 400;
          color: rgba(255,255,255,0.702);
          line-height: 14px;
        }
        .s-count {
          margin-top: 10px;
          height: 18px;
          .s-num {
            font-size: 20px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 20px;
          }
          .sq {
            height: 100%;
            margin-left: 8px;
            font-size: 14px;
            font-weight: 700;
            color: #06F7A1;
            .p {
              width: 0;
              height: 0;
              border: 4px solid;
              margin-right: 4px;
              margin-top: 4px;
            }
            .p1-color {
              border-color: #06F7A1 transparent transparent transparent;
            }
            .p2-color {
              border-color: #FF6637 transparent transparent transparent;
              transform: rotate(180deg);
              margin-top: -4px;
            }
          }
          .sp-1 {
            color: #FF6637;
          }
        }
      }
    }
  }
</style>